import { computed, unref } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { maskText as maskTextHelper } from 'shared/helpers/dataMasking';

/**
 * Resolve as regras de masking de um inbox e expoe maskText memoizado.
 * @param {import('vue').Ref<number|string>|number|string} inboxId
 */
export const useMessageMasking = inboxId => {
  const inboxGetter = useMapGetter('inboxes/getInboxById');

  const maskingConfig = computed(() => {
    const id = unref(inboxId);
    if (!id) return null;
    const inbox = inboxGetter.value(id);
    return inbox?.maskingConfig || null;
  });

  const isEnabled = computed(() => maskingConfig.value?.enabled === true);

  const applyToOutgoing = computed(
    () => maskingConfig.value?.applyToOutgoing !== false
  );

  const maskingRules = computed(() =>
    isEnabled.value ? maskingConfig.value?.rules || [] : []
  );

  const hasMasking = computed(() => maskingRules.value.length > 0);

  /**
   * @param {string} text
   * @param {{ isOutgoing?: boolean }} [opts]
   */
  const maskText = (text, { isOutgoing = false } = {}) => {
    if (!hasMasking.value) return text;
    if (isOutgoing && !applyToOutgoing.value) return text;
    return maskTextHelper(text, maskingRules.value);
  };

  return { maskingConfig, maskingRules, hasMasking, maskText };
};
